<template>
  <c-card elevation="0" class="bg-white pa-4 fill-height d-flex flex-column align-content-space-between py-4 px-5">
    <p class="font-weight-bold mb-0 text-body-1 line-height-100 text-black mb-4">
      {{ $t('main.your_support') }}
    </p>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center name-width">
        <v-avatar size="32px">
          <v-img :src="managerInfo.avatar" alt="manager avatar">
            <template #placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="secondary-100" />
              </v-row>
            </template>
          </v-img>
        </v-avatar>
        <div class="ml-2">
          <div class="text-body-1 line-height-100 text-black text-truncate mb-1">
            {{ managerInfo.name }}
          </div>
          <div class="height-14 line-truncate text-secondary-600 text-caption">
            {{ managerInfo.description }}
          </div>
        </div>
      </div>
      <manager-contacts :is-minimized="true" :is-main="true" :manager-info="managerInfo" />
    </div>
  </c-card>
</template>

<script>
  import { CCard } from '@clickadilla/components/components'
  import ManagerContacts from '@/components/PersonalManagerCard/ManagerContacts.vue'

  export default {
    name: 'ManagerMainCard',
    components: {
      ManagerContacts,
      CCard
    },
    props: {
      managerInfo: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
  .name-width {
    max-width: calc(100% - 70px);
  }
  .width-12 {
    width: 12px;
    height: 12px;
  }
  .line-height-100 {
    line-height: 100%!important;
  }
  .height-14 {
    line-height: 14px;
  }
  .line-truncate {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
